import colors from '../../colors';
import styles from "./styles.scss";
import MessageBubble from "../../containers/MessageBubble/MessageBubble";
import {createRef, Fragment} from "preact";
import {OrganizationContext} from "../../contexts";
import {getProfile} from "../../selectors";
import Icon from "../Icon/Icon";
import { Component } from "preact";

let currentIdx = 0;
let colorIndexes = {};

const mapInternalIdToColor = internalId => {
  if (colorIndexes[internalId])
    return colors[colorIndexes[internalId]];
  colorIndexes[internalId] = currentIdx;
  currentIdx = (currentIdx + 1) % colors.length;
  return colors[colorIndexes[internalId]];
};

/**
 * A class component because hooks don't have getSnapshotBeforeUpdate yet
 * @param onRequestMoreMessages
 * @param messages
 * @param displaySenderNames
 * @param roomDetails ONLY MODERATORS HAVE ACCESS TO ROOM DETAILS!
 * @returns {*}
 * @constructor
 */
class ChatContents extends Component {
  constructor() {
    super();
    this.state = {
      isLocked: false,
      fetchedMessagesArrived: true,
      hasRequestedMessages: false,
      messagesEnded: false,
    };
    this.containerRef = createRef();
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  setLocked = (locked) => {
    if (locked !== this.state.isLocked)
      this.setState({isLocked: locked});
  };

  scrollToBottom = () => {
    if (this.containerRef && this.containerRef.current) {
      this.containerRef.current.scroll({ top: 9999999 });
    }
  };

  onScroll = evt => {
    const element = evt.target;
    if (element.scrollTop < 300 && !this.state.hasRequestedMessages && !this.state.messagesEnded) {
      this.setState({hasRequestedMessages: true});
      this.props.onRequestMoreMessages().then(data => {
        this.setState({fetchedMessagesArrived: true, messagesEnded: data.ended});
      });
    }

    this.setLocked(!(element.scrollHeight - element.scrollTop <= (element.clientHeight + 10)));
  };

  getSnapshotBeforeUpdate(prevProps, prevState) {
    // are we adding new items to the list?
    // capture the scroll position so we can adjust scroll later
    const isAddingItems = prevProps.messages.length < this.props.messages.length;
    const { fetchedMessagesArrived, isLocked } = this.state;

    if (isAddingItems && (fetchedMessagesArrived || !isLocked)) {
      const list = this.containerRef.current;
      const curScrollPos = list.scrollTop;
      const oldScroll = list.scrollHeight - list.clientHeight;
      this.setState({fetchedMessagesArrived: false, hasRequestedMessages: false});
      return { curScrollPos, oldScroll };
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if we have a snapshot value, we've just added new items
    // adjust scroll so these new items don't push the old ones ouf of view
    if (snapshot) {
      const list = this.containerRef.current;
      const newScroll = list.scrollHeight - list.clientHeight;
      list.scrollTop = snapshot.curScrollPos + (newScroll - snapshot.oldScroll);

    }
  }

  render = () => {
    const now = new Date().toISOString();
    let silencedUsers = [];

    if (this.props.roomDetails) {
      silencedUsers = this.props.roomDetails.members.filter(m => m.timeout && m.timeout > now).map(m => m.internalId);
    }

    const { isLocked } = this.state;
    const { messages, displaySenderNames, onRequestSilenceUser, internalId, onRequestSearch } = this.props;
    const { scrollToBottom, onScroll } = this;

    return (
      <OrganizationContext.Consumer>
        {organization => <Fragment>
          <div className={styles.container} ref={this.containerRef} onScroll={onScroll}>
            {messages
              .map(message => ({
                ...message,
                sentAt: new Date(message.sentAt),
                sender: displaySenderNames ? {internal_id: message.senderInternalId, name: message.senderLabel} : getProfile(organization, message.senderInternalId),
              }))
              .map(message => ({
                ...message,
                senderColor: displaySenderNames ? mapInternalIdToColor(message.sender.internal_id) : ''
              }))
              .map((message, index) => (
                <MessageBubble
                  message={message}
                  senderName={displaySenderNames && message.sender.internal_id !== internalId && message.sender.name}
                  senderColor={displaySenderNames && message.sender.internal_id !== internalId && message.senderColor}
                  onRequestSearch={onRequestSearch}
                  content={message.content}
                  hiddenByModerator={message.hiddenByModerator}
                  readBy={message.readBy}
                  internalId={message.sender.internal_id}
                  key={index}
                  isOwner={internalId === message.sender.internal_id}
                  isAppended={
                    index !== 0 &&
                    messages[index - 1].senderInternalId === message.sender.internal_id
                  }
                  roomId={message.roomId}
                  messageId={message.id}
                  timestamp={`${message.sentAt
                    .getHours()
                    .toString()
                    .padStart(2, "0")}:${message.sentAt
                    .getMinutes()
                    .toString()
                    .padStart(2, "0")}`}
                  isSilenced={silencedUsers.includes(message.sender.internal_id)}
                  onRequestSilenceUser={onRequestSilenceUser}
                />
              ))}
            {
              isLocked && <button type="submit" className={styles.scrollToBottomBtn} onClick={scrollToBottom}>
                <Icon name="chevron_down" />
              </button>
            }
          </div>
        </Fragment>}
      </OrganizationContext.Consumer>
    );
  };
}

export default ChatContents;



// WEBPACK FOOTER //
// ./components/chat-contents/index.js